import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { createCropValidationSchema } from "../../components/Custom/ValidationSchema";
import CustomCard from "../../components/Famer/GenericCard";
import { getProgramInputs, getProgram } from "../../api/programs";

const validationSchema = createCropValidationSchema();

export default function EditProgram() {
  const navigate = useNavigate();
  const { programId } = useParams();

  const [formData, setFormData] = useState({});
  const [programInputs, setProgramInputs] = useState([{}]);
  const { t } = useTranslation();
  const { errors, validate } = useFormValidation(formData, validationSchema);

  useEffect(() => {
    const loadProgram = async () => {
      setFormData(await getProgram(programId));
    };

    const loadProgramInputs = async () => {
      setProgramInputs(await getProgramInputs(programId));
    };

    loadProgram();
    loadProgramInputs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...formData, [name]: value });
  };

  const addProgramInput = async () => {
    navigate(`/programs/${programId}/add-input`);
  };

  const uploadProgramInput = async () => {
    navigate(`/programs/${programId}/upload-inputs`);
  };

  const editProgramInput = async (programInputId) => {
    navigate(`/programs/program-input/${programInputId}`);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Edit Program")}</CustomTitle>

            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Program Name")}
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.name}
              helperText={errors.name}
            />

            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(115vh - 300px)",
                textAlign: "center",
              }}
            >
              {programInputs.map((programInput) => (
                <CustomCard
                  key={programInput.id}
                  id={programInput.id}
                  t={t}
                  data={{
                    [t("Name")]: programInput.name,
                  }}
                  handlePrimaryButton={() => editProgramInput(programInput.id)}
                  // handleEditClick={() => handleEditClick(crop.id)}
                  // handleDelete={() => handleDelete(crop.id)}
                />
              ))}
            </div>
            <CustomButton onClick={uploadProgramInput}>
              {t("Upload Program Inputs")}
            </CustomButton>
            <CustomButton onClick={addProgramInput}>
              {t("Add Input Supply")}
            </CustomButton>
            {/* <CustomButton onClick={handleSubmit}>{t("Save")}</CustomButton> */}
          </Grid>
        </div>
      </Container>
    </>
  );
}
